export default __webpack_public_path__ + "static/media/logo-large.556b3d5e.png";